import LocalTextInput from 'components/FilterPanel/LocalTextInput';
import React from 'react';
import Points from 'components/Points';
import { AssetUrls } from 'config/assets';
import './PointsRangeControl.css';

// A min/max points range. Generic patch keys so one control serves both Point
// value (URL state, mapped to pointsMin/pointsMax by FilterPanel) and Trader
// balance (page state). The inputs show that they are points: the coin inside
// the field and the value in the Points component's Georgia gold (Asana
// 1219008751039721, decision 10).

interface PointsRangeControlProps {
  min: string;
  max: string;
  onChange: (patch: { min?: string; max?: string }) => void;
  /** Accessible names; the defaults keep the Point value wording. */
  minLabel?: string;
  maxLabel?: string;
}

const digitsOnly = (value: string) => value.replace(/\D/g, '');

const Coin: React.FC = () => (
  <img className="points-range-coin" src={AssetUrls.icons.profile.coin} width={18} height={18} alt="" aria-hidden="true" />
);

export const PointsRangeControl: React.FC<PointsRangeControlProps> = ({
  min,
  max,
  onChange,
  minLabel = 'Minimum points',
  maxLabel = 'Maximum points',
}) => {
  const minValue = min !== '' ? Number(min) : null;
  const maxValue = max !== '' ? Number(max) : null;

  return (
    <div className="points-range-control">
      <div className="points-range-inputs">
        <span className="points-range-field">
          <Coin />
          <LocalTextInput
            type="text"
            inputMode="numeric"
            className="points-range-input"
            placeholder="Min"
            aria-label={minLabel}
            value={min}
            sanitize={digitsOnly}
            onValueChange={(v) => onChange({ min: v })}
          />
        </span>
        <span className="points-range-separator">to</span>
        <span className="points-range-field">
          <Coin />
          <LocalTextInput
            type="text"
            inputMode="numeric"
            className="points-range-input"
            placeholder="Max"
            aria-label={maxLabel}
            value={max}
            sanitize={digitsOnly}
            onValueChange={(v) => onChange({ max: v })}
          />
        </span>
      </div>

      {(minValue !== null || maxValue !== null) && (
        <div className="points-range-echo">
          {minValue !== null && <Points points={minValue} type="small" />}
          {minValue !== null && maxValue !== null && <span className="points-range-dash">-</span>}
          {maxValue !== null && <Points points={maxValue} type="small" />}
        </div>
      )}
    </div>
  );
};

export default PointsRangeControl;
